var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoPlayerPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 41,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.75,
    cy: 20.5,
    r: 20.5,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.23 15.694c.279-2.062 2.095-3.225 4.028-2.455 1.218.485 2.815 1.213 4.87 2.305a59.013 59.013 0 014.666 2.735c2.106 1.38 2.106 4.062 0 5.443a59.266 59.266 0 01-4.665 2.735c-2.056 1.091-3.654 1.819-4.871 2.304-1.933.77-3.75-.393-4.029-2.455A39.604 39.604 0 0114.885 21c0-2.119.155-3.909.344-5.306z",
    fill: "#1253FA"
  })));
}
export default SvgVideoPlayerPlay;